import * as modal from "../../util/modal.ts";
import * as amplify from "../../util/amplify.ts";
import * as i18n from "../../i18n.ts";
import {getCache,setCurrentBudget,getCurrentBudget,buildTransactionList,buildSummary} from "../../server/objects/BudgetBeans.js";

import TPL_editlimit from "../../budget/budget_limit.mustache";
import TPL_catlimit from "../../budget/modal_categorieslimit.mustache";

export {openCategoryLimitModal,openLimitModal}

const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();

function openCategoryLimitModal(budgetBean){
  let 
    items = budgetCategoryCache.filtered().filter(cat=>cat.budgetTransactionType==='EXPENSE').map(category=>{return {
      metaId:category.metaId,
      category:category,
      limit:budgetBean.budgetCategoryLimits[category.metaId]||0,
      currencyCode:budgetBean.currencyCode
      }}),
    catLimitModal = modal.openModal(TPL_catlimit,{
      items:items,
      budgetLimit:budgetBean.budgetLimit}),
    percentNumber =  catLimitModal.find('.percentNumber'),
    rawNumber =  catLimitModal.find('.rawNumber'),
    percentBar =  catLimitModal.find('.percentBar'),
    leftNumber =  catLimitModal.find('.leftNumber');
  function getTotal(){
    var total = 0;
    catLimitModal.find('input[type=amount]').each((idx,input)=>{
      input = $(input)
      var val = input.amountValue()
      total+=val;
      input.amountValue(val)
    })
    return total;
  }
  function updateCategoryUI(){
    var 
      total = getTotal(), 
      max = budgetBean.budgetLimit,
      percent = 100*total/max,
      left = max-total;
    percentNumber.html(i18n.get("budgetlimit.percentset",percent.toFixed(0)+'%'));
    percentBar.find('span')
      .css('width',percent.toFixed(1)+'%')
      .css('background-color',percent>100?"red":"var(--brand-color)");
    rawNumber.html(budgetBean.formatAmount( total)+ '/'+budgetBean.formatAmount(max));
    if(left>=0){
      leftNumber.html(i18n.get("budgetlimit.lefttoallocate",budgetBean.formatAmount(left)));
    }else{
      leftNumber.html(i18n.get("budgetlimit.overallocated",budgetBean.formatAmount(-left)));
    }
    
    //submitButton.prop('disabled',percent>100)
  }     
  updateCategoryUI()
  catLimitModal.delegate('input[type=amount]','change',updateCategoryUI)
  catLimitModal.delegate('input[type=amount]','focus',function(){$(this).select()})
  
  catLimitModal.find('form').on('submit',function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    var 
      total = getTotal(),
      budgetCategoryLimits = {};
      catLimitModal.find('input[type=amount]').each((idx,input)=>{
        budgetCategoryLimits[$(input).metaId()]=$(input).amountValue()
      })
      
    if(total>budgetBean.budgetLimit){
      modal.ask({
        title:"budgetlimit.exceededtitle",
        message:i18n.get("budgetlimit.exceededtext",{budgetLimit:budgetBean.formatAmount(budgetBean.budgetLimit),budgetLimitTarget:budgetBean.formatAmount(total),budgetLimitExcess:budgetBean.formatAmount(total-budgetBean.budgetLimit)}),
        lottie:"images/lottie/face_with_monocle.json",
        button:[
          {title:"actions.proceed",onclick:function(){
            budgetBean.budgetLimit=total;
            budgetBean.budgetLimitCategoryActive = true;
            budgetBean.budgetCategoryLimits = budgetCategoryLimits;
            amplify.publish("budgetmodified");
            modal.closeModal();}},
          {title:"actions.cancel",class:"secondary"}
        ]
      })
    }else{
      budgetBean.budgetCategoryLimits = budgetCategoryLimits;
      budgetBean.budgetLimitCategoryActive = true;
      amplify.publish("budgetmodified");
      modal.closeModal();  
    }
  })
  catLimitModal.onClose =function(){
    if(getTotal()>budgetBean.budgetLimit){
      budgetBean.budgetLimitCategoryActive = false;
     }else{
      budgetBean.budgetLimitCategoryActive = true;
    }
  }
}

function openLimitModal(budgetBean,wanachangeInfo){
  var 
      limitModal = modal.openModal(TPL_editlimit,{currencyCode:budgetBean.currencyCode,budgetLimit:budgetBean.budgetLimit,wanachangeInfo:wanachangeInfo});
    
    setTimeout(function(){limitModal.find('input').select()},100) //the time for widgets to execute  
    limitModal.find('form').on('submit',function(event){
      event.preventDefault();
      var value = $(this).find('input').amountValue();
      if(value===0){
        modal.ask({
          title:"budgetlimit.limit0",
          message:"budgetlimit.limit0text",
          lottie:"/images/lottie/face_with_monocle.json",
          button:[
            {class:'negative',title:'actions.disable',onclick:function(){budgetBean.budgetLimitActive=false;amplify.publish("budgetmodified");modal.closeModal();}},
            {class:'secondary',title:'actions.cancel',onclick:function(){limitModal.find('input').select()}}
          ]
        })
      }else{
        budgetBean.budgetLimitActive=true;
        budgetBean.budgetLimit = value;
        amplify.publish("budgetmodified");
        modal.closeModal();
        modal.ask({
          title:"budgetlimit.askcategory",
          message:"budgetlimit.askcategorytext",
          lottie:"/images/lottie/face_with_monocle.json",
          button:[
            {title:'budgetlimit.askcategorybutton',onclick:function(){openCategoryLimitModal(budgetBean)}},
            {class:'secondary',title:'actions.later'}
          ]
        })
      }
    })
}